module.exports = __webpack_public_path__ + "img/logo.3f7e84e7.svg";